export default __webpack_public_path__ + "static/media/mechasense_logo.a5f86d2e.svg";